module.exports = __webpack_public_path__ + "static/image 6-8ba5713b36c5d0825f4d7161c65dcb11.png";